import Link from 'next/link';
import * as S from './styles';

const BannerEnterprise = () => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;

  return (
    <S.Container>
      <Link href={'/enterprise/landing'}>
        <S.Title>맘카페부터 블로그까지, 우리 병원 리뷰 한눈에 확인하기</S.Title>
        <S.Description>주요 플랫폼 리뷰는 물론 카페, 블로그 등 커뮤니티 리뷰까지 모니터링해요</S.Description>
        <S.BannerImage src={`${baseImageUrl}/banner/banner-enterprise.png?v=1.0`} alt={'엔터프라이즈 배너'} width={436} height={160} />
      </Link>
    </S.Container>
  );
};

export default BannerEnterprise;
